import React from 'react'

const OrderInfoContext = React.createContext();

//export const OrderInfoProvider = OrderInfoContext.Provider;
//export const OrderInfoConsumer = OrderInfoContext.Consumer;

export default OrderInfoContext;
